import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/api/client";
import { useAuth } from "@/auth/AuthProvider";
import { Loader2 } from "lucide-react";
import { consumeReturnTo } from "@/lib/oauthReturn";

export function OAuthCallbackPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code || !state) {
      setError(t("oauthCallback.missingParams"));
      return;
    }

    api("/api/v2/git-auth/callback", {
      method: "POST",
      body: JSON.stringify({ code, state }),
    })
      .then(() => {
        const orgSlug = user?.org_slug ?? "";
        const returnTo = consumeReturnTo(state);
        navigate(returnTo ?? `/${orgSlug}/onboarding/wizard?connected=true`, { replace: true });
      })
      .catch(() => {
        setError(t("oauthCallback.authFailed"));
      });
  }, [searchParams, navigate, user, t]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-destructive">{error}</p>
          <button
            onClick={() => navigate(-1)}
            className="text-sm underline text-muted-foreground"
          >
            {t("oauthCallback.goBack")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex items-center gap-3">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-muted-foreground">{t("oauthCallback.completing")}</span>
      </div>
    </div>
  );
}
